import ExerciseEmptyLines from "../../detailsSubComponents/exerciseEmptyLines/ExerciseEmptyLines";
import FreeTextHeaderActions from "../../detailsSubComponents/freeTextHeaderActions/FreeTextHeaderActions";

import { Wrapper } from "../../StyledComponents";

interface DetailsFreeTextProps {
    isSelectExerciseVocabularyOpen: boolean;
    onClickAddVocabularyButton: () => void;
}

const DetailsFreeText = (props: DetailsFreeTextProps) => {
    return (
        <Wrapper>
            <FreeTextHeaderActions
                isSelectExerciseVocabularyOpen={props.isSelectExerciseVocabularyOpen}
                onClickAddVocabularyButton={props.onClickAddVocabularyButton}
            />
            <ExerciseEmptyLines linesAmount={6} />
        </Wrapper>
    );
};

export default DetailsFreeText;
